import axios from "axios"
import { config } from './apiUrl';

export  const getGallery = (qid) =>
    axios.get(`${config.getPhotoUrl}?qid=${qid}`)

export  const getGallerybyId = (id,qid) =>
    axios.get(`${config.getPhotoUrl}?album_id=${id}&qid=${qid}`)
